import { render, staticRenderFns } from "./MasterPengguna_magister.vue?vue&type=template&id=40ad46e8"
import script from "./MasterPengguna_magister.vue?vue&type=script&lang=js"
export * from "./MasterPengguna_magister.vue?vue&type=script&lang=js"
import style0 from "./MasterPengguna_magister.vue?vue&type=style&index=0&id=40ad46e8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports